import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import { ContentProvider, useContent } from "./content/ContentContext";
import ProtectedRoute from "./auth/ProtectedRoute";

import Header from "./components/seechelle/Header";
import Hero from "./components/seechelle/Hero";
import SocialProofBar from "./components/seechelle/SocialProofBar";
import TrustStrip from "./components/seechelle/TrustStrip";
import About from "./components/seechelle/About";
import WhyWorkWithMe from "./components/seechelle/WhyWorkWithMe";
import Services from "./components/seechelle/Services";
import HowWeWork from "./components/seechelle/HowWeWork";
import Testimonials from "./components/seechelle/Testimonials";
import MissionVision from "./components/seechelle/MissionVision";
import ContactSection from "./components/seechelle/ContactSection";
import Footer from "./components/seechelle/Footer";

import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminContentSection from "./admin/AdminContentSection";
import AdminInbox from "./admin/AdminInbox";
import AdminMedia from "./admin/AdminMedia";

const HomePage = () => {
  const g = useContent("global");
  const calendly = g.calendly_url;
  const linkedin = g.linkedin_url;
  const headshot = g.headshot_url;

  React.useEffect(() => {
    if (g.site_title) document.title = g.site_title;
  }, [g.site_title]);

  return (
    <div className="bg-white text-ink antialiased" data-testid="home-page">
      <Header calendlyUrl={calendly} />
      <main>
        <Hero calendlyUrl={calendly} />
        <SocialProofBar />
        <TrustStrip />
        <About linkedinUrl={linkedin} headshotUrl={headshot} />
        <WhyWorkWithMe />
        <Services calendlyUrl={calendly} />
        <HowWeWork />
        <Testimonials />
        <MissionVision />
        <ContactSection calendlyUrl={calendly} />
      </main>
      <Footer calendlyUrl={calendly} linkedinUrl={linkedin} />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminDashboard />} />
              <Route path="content/:section" element={<AdminContentSection />} />
              <Route path="inbox" element={<AdminInbox />} />
              <Route path="media" element={<AdminMedia />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
